import React from 'react';
import View from './View';

import { SidebarPortal } from '@plone/volto/components';
import AltmetricSidebar from './Sidebar';

const Edit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  return (
    <div className="block altmetric edit">
      <View {...props} />
      <SidebarPortal selected={selected}>
        <AltmetricSidebar
          {...props}
          data={data}
          block={block}
          onChangeBlock={onChangeBlock}
        />
      </SidebarPortal>
    </div>
  );
};

export default Edit;
